<template>
  <v-btn icon color="info" title="Editar experiência" @click="editarExp()"
    ><v-icon>mdi-pencil-outline</v-icon></v-btn
  >
</template>

<script>
import { mapMutations } from "vuex";
export default {
  props: {
    experiencia: { type: Object, required: true },
  },
  methods: {
    ...mapMutations(["setDialogManutExpProf", "setExperiencia"]),
    editarExp() {
      this.setExperiencia(this.experiencia);
      this.setDialogManutExpProf(true);
    },
  },
};
</script>

<style>
</style>